import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
export const BuyButton = ({ deviation: { deviationId , print: { lowestPrice , purchaseUrl  } = {}  } , className  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement(ActionBarB18Link, {
        href: purchaseUrl,
        biData: {
            evid: BiEventType.BUY_CLICK,
            deviationid: deviationId
        }
    }, lowestPrice ? t('actionbar.buyFor', {
        price: lowestPrice
    }) : t('actionbar.buy')));
};
BuyButton.displayName = 'BuyButton';
export default BuyButton;
